<template>
  <div>
    <div>
      <DxFileUploader
        accept="image/*"
        ref="fileUploader"
        :multiple="false"
        upload-mode="instantly"
        :upload-url="fileUploadUrl"
        :upload-headers="headers"
        name="files"
        @uploaded="onUploaded($event)"
      />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { DxFileUploader } from 'devextreme-vue/file-uploader'

export default {
  name: 'ImageUpload',
  props: ['initFileName'],
  components: {
    DxFileUploader
  },
  data () {
    return {
      headers: {},
      callFileUploadUrl: '',
      fileName: this.initFileName || '',
      fileList: [],
      // fileUploadUrl: 'http://localhost:8090/api/purchase/customerCare/imageUpload',
      fileUploadUrl: '/api/purchase/cmm/ImageUpload'
    }
  },
  methods: {
    onUploaded (e) {	// 업로드 후
      const { status, result } = JSON.parse(e.request.response)
      if (status === '200') {
        this.fileName = result
        this.$emit('changeFileName', this.fileName)
      }
    }
  },
  watch : {
    '$route' (from, to) {
      console.log(`${from.name} , ${to.name}`)      
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.headers = {'x-auth-token': Vue.httpClient.defaults.headers.common['x-auth-token']}      
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/purchase/cmm/ImageUpload.vue